import { Link } from "react-router-dom"
import { Button } from "../components/ui/button"
import { Calendar, CheckCircle, ChevronRight } from "lucide-react"
import { useEffect, useState } from "react"
import { Badge } from "../components/ui/badge"
import SEO from "./SEO"

import Diagnosticswidget from "../components/widgets/diagnostics"
import Healthcheckupspackageswidget from "../components/widgets/healthcheckupspackages"

export default function DiagnosticsPage() {
  const diagnosticsSchema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "Pranaam Hospitals Diagnostics",
    "url": "https://pranaamhospitals.com/diagnostics",
    "logo": "https://pranaamhospitals.com/wp-content/uploads/2025/logo.png",
    "description": "Pranaam Hospitals Diagnostics provides advanced diagnostic services including pathology, imaging, and cardiac diagnostics with accurate and timely results in Hyderabad.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "addressCountry": "IN"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "diagnostic services",
        "telephone": "+91-99660-60000",
        "availableLanguage": ["English", "Telugu", "Hindi"]
      }
    ],
    "parentOrganization": {
      "@type": "MedicalOrganization",
      "name": "Pranaam Hospitals",
      "url": "https://pranaamhospitals.com/"
    }
  },

  {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://pranaamhospitals.com/diagnostics"
    },
    "headline": "Advanced Diagnostic Services at Pranaam Hospitals",
    "description": "Explore comprehensive diagnostic services at Pranaam Hospitals including blood tests, imaging, MRI, CT scans, cardiac diagnostics, and walk-in testing.",
    "author": {
      "@type": "Organization",
      "name": "Pranaam Hospitals"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Pranaam Hospitals",
      "logo": {
        "@type": "ImageObject",
        "url": "https://pranaamhospitals.com/wp-content/uploads/2025/logo.png"
      }
    },
    "datePublished": "2015-01-01",
    "dateModified": "2025-04-01",
    "keywords": [
      "diagnostic center Hyderabad",
      "MRI CT scan Hyderabad",
      "pathology lab Hyderabad",
      "cardiac diagnostics Hyderabad"
    ],
    "articleSection": [
      "Pathology & Blood Tests",
      "Imaging Services",
      "Cardiac Diagnostics",
      "Walk-in Diagnostic Testing"
    ]
  }
];



const [data, setData] = useState(null)
const [servicesData, setServicesData] = useState(null)
const [faqData, setFaqData] = useState(null)
const [seo, setSeo] = useState({});
const [pageKeywords, setPageKeywords] = useState("");
useEffect(() => {
  fetch("/wp-json/custom/v1/diagnostic-services?page_id=21383")
    .then(res => res.json())
    .then(res => {
      console.log("API DATA 👉", res)
      setData(res)
    })

    fetch("/wp-json/custom/v1/faqs?page_id=21383")
    .then(res => res.json())
    .then(res => {
      console.log("FAQ 👉", res)
      setFaqData(res)
    })

    fetch("/wp-json/custom/v1/page-seo?slug=diagnostics")
    .then(res => res.json())
    .then(data => { if (data?.seo) setSeo(data.seo); setPageKeywords(data?.keywords || ""); })
    .catch(() => {})

}, [])

  if (!data) return null

  return (
    <>
    <SEO
  title={seo.title || "Advanced Diagnostics in Hyderabad | Pranaam Hospitals"}
  description={seo.description || "Pranaam Hospitals offers advanced diagnostic services in Hyderabad including blood tests, MRI, CT scan, X-ray, cardiac diagnostics, and walk-in testing with accurate results."}
  canonical={seo.canonical || "https://pranaamhospitals.com/diagnostics"}
  robots={Array.isArray(seo.robots) ? seo.robots.join(", ") : seo.robots || "index, follow"}
  keywords={pageKeywords}
  ogTitle={seo.og_title}
  ogDescription={seo.og_description}
  ogImage={seo.og_image || seo.featured_image}
  twitterTitle={seo.twitter_title}
  twitterDescription={seo.twitter_description}
  author="Pranaam Hospitals"
  publisher="Pranaam Hospitals"
  schema={diagnosticsSchema}
/>

    <main className="min-h-screen">
      {/* Hero Section */}
      <Diagnosticswidget />

      {/* Test Categories */}
      <section className="py-12 bg-white">
      <div className="container px-4 mx-auto">

        <h2 className="mb-8 text-2xl font-bold text-center md:text-3xl">
          {data?.title || "Our Diagnostic Services"}
        </h2>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">

          {data?.items?.map((service, index) => (
            <div key={index} className="p-6 bg-white border rounded-lg shadow-sm">

              <h3 className="mb-4 text-xl font-bold">
                {service.title}
              </h3>

              <ul className="space-y-2">
                {service.items?.map((item, idx) => (
                  <li key={idx}>{item.name}</li>
                ))}
              </ul>

            </div>
          ))}

        </div>

      </div>
      </section>

      {/* Health Packages */}
      <Healthcheckupspackageswidget />


      {/* FAQ Section */}
   <section className="py-12 bg-white">
  <div className="container px-4 mx-auto">

    <h2 className="mb-8 text-2xl font-bold text-center md:text-3xl">
      {faqData?.title || "Frequently Asked Questions"}
    </h2>

    <div className="max-w-3xl mx-auto space-y-6">

      {faqData?.items?.map((faq, index) => (
        <div key={index} className="p-6 bg-white border rounded-lg shadow-sm">

          <h3 className="mb-2 text-lg font-bold">
            {faq.question}
          </h3>

          <p className="text-muted-foreground">
            {faq.answer}
          </p>

        </div>
      ))}

    </div>

  </div>
</section>

      {/* CTA Section */}
      {/* <section className="py-12 bg-primary text-white">
        <div className="container px-4 mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="mb-4 text-2xl font-bold md:text-3xl">Book Your Diagnostic Test Today</h2>
            <p className="mb-6">
              Take a proactive step towards better health. Our state-of-the-art diagnostic center is equipped to provide
              you with accurate and timely results.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Button size="lg" variant="secondary" asChild>
                <a
                    href="https://pranaam365.com/"
                    className="flex items-center gap-2"
                  >
                    Book a Test
                    <Calendar className="w-4 h-4" />
                  </a>
              </Button>
              <Button size="lg" variant="outline" className="bg-transparent text-white border-white" asChild>
                <Link to="/contact">Contact Us</Link>
              </Button>
            </div>
          </div>
        </div>
      </section> */}
    </main>
    </>
  )
}
